/** A new enrollment token, shown once, with what to do with it. */
import { html } from 'lit';

import { when } from './time.js';

/**
 * The token as the plane issued it (`{ serverId, token, expiresAt }`). The plane keeps only its
 * hash: once this card is gone the token cannot be shown again, only replaced.
 */
export const enrollmentTokenCard = (issued, onDismiss) => html`
  <div class="notice" data-tone="warning" role="status">
    <strong>Enrollment token for <code>${issued.serverId}</code></strong>
    <p>Copy it now: it is shown only once. It works once, expires ${when(issued.expiresAt)}, and replaces any token issued before.</p>
    <code class="token">${issued.token}</code>
    <p>Put it in the hop vault of the server and deploy the clawlet: it enrolls at start, with a key of its own.</p>
    <pre><code>printf %s '${issued.token}' &gt; ~/.hop/vault/&lt;hop-server&gt;/secrets/clawlet-enrollment-token
hop app deploy --app ./.hop/resources/app/clawlet/ --server &lt;hop-server&gt;</code></pre>
    ${onDismiss ? html`<p><button class="small" @click=${onDismiss}>I have copied it</button></p>` : null}
  </div>
`;
